import { Attachment } from "./attachment";
import { Edition } from "./edition";

export class Page {
    public __classname__: string = 'Page';

    public Width : number | null = null;
	public Height : number | null = null;
	public PageNumber : string | null = null;
	public PageOrder : number | null = null;
	public Files : Attachment[] | null = null;
	public Edition : Edition | null = null;
	public Master : string | null = null;
	public Instance : string | null = null;
	public PageSequence : number | null = null;
	public Renditions : string[] | null = null;
	public Orientation : string | null = null;

    constructor(
        Width: number | null = null,
        Height: number | null = null,
        PageNumber: string | null = null,
        PageOrder: number | null = null,
        Files: Attachment[] | null = null,
        Edition: Edition | null = null,
        Master: string | null = null,
        Instance: string | null = null,
        PageSequence: number | null = null,
        Renditions: string[] | null = null,
        Orientation: string | null = null
    ) {
        this.Width = Width;
        this.Height = Height;
        this.PageNumber = PageNumber;
        this.PageOrder = PageOrder;
        this.Files = Files;
        this.Edition = Edition;
        this.Master = Master;
        this.Instance = Instance;
        this.PageSequence = PageSequence;
        this.Renditions = Renditions;
        this.Orientation = Orientation;
    }

}